<template>
  <div class="point-d">
    <subfield>
      <template slot="list">
        <trees :title="$t('cspm1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <el-button icon="el-icon-plus" size="mini" type="primary" round @click="addPoint">{{ $t('terminal.add') }}</el-button>
              <!-- <el-button icon="el-icon-delete" size="mini" type="danger" round>删除</el-button> -->
            </div>
            <div class="c-u-right">
            </div>
          </template>
          <template slot="center">
            <!-- <el-table :data="pointList" :span-method="objectSpanMethod" style="width: 100%" height="100%" border>
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="name" label="名称" width="180">
              </el-table-column>
              <el-table-column prop="point" label="位置">
              </el-table-column>
              <el-table-column label="播放范围" width="100">
                <template slot-scope="scope">
                  {{ scope.row.radius }}km
                </template>
</el-table-column>
<el-table-column prop="play_name" label="播放类容">
</el-table-column>
<el-table-column label="操作" width="144">
  <template slot-scope="scope">
                  <el-button type="primary" size="mini">编辑</el-button>
                  <el-button type="danger" size="mini" @click="delPoint(scope.row.name)">删除</el-button>
                </template>
</el-table-column>
</el-table> -->
            <point-list :pointList="pointListValue" />
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>

      </template>
    </subfield>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
// import DelDialog from '@/components/basics/DelDialog'
import trees from '@/components/basics/Trees'
import PointList from '@/components/basics/PointList'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";

export default {
  name: "PointDelivery",
  mixins: [mPagination],
  components: {
    subfield,
    EnfoldUcd,
    trees,
    pagination,
    PointList
  },
  computed: {
  },
  data() {
    return {
      groupList: [],
      pointListValue: [],
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getPoint();
  },
  methods: {
    getAssets(ids) {
      this.groupIds = ids.ids;
      this.getPoint();
    },
    currentChange(val) {
      this.page = val;
    },
    getPoint() {
      this.$http.post("/admin/device/getPoint", {
        group_ids: this.groupIds
      }, data => {
        this.pointListValue = data;
      });
    },

    addPoint() {
      if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_VERSION === '124') {
        this.$router.push({ name: "AddGooglePoint", params: { type: '1' } });
      }else{
        this.$router.push({ name: "AddPoint", params: { type: '1' } });
      }
    },
    // delPoint(name) {
    //   let ids = this.pointList.filter(p => p.name == name).map(p => p.id);
    //   this.$http.post("/admin/device/delPoint", {
    //     ids: ids.join(",")
    //   }, () => {
    //     this.getPoint();
    //   });
    // },
    // // eslint-disable-next-line no-unused-vars
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   console.log(row, column, rowIndex, columnIndex);
    //   if (columnIndex === 0 || columnIndex === 1 || columnIndex === 5) { // 只在第一列（Name 列）合并单元格  
    //     const prevRow = this.pointList[rowIndex - 1];
    //     if (prevRow && prevRow.name === row.name) {
    //       return {
    //         rowspan: 0,
    //         colspan: 1,
    //       };
    //     } else {
    //       let count = 1;
    //       let nextRow = this.pointList[rowIndex + 1];
    //       while (nextRow && nextRow.name === row.name) {
    //         count++;
    //         nextRow = this.pointList[rowIndex + count];
    //       }
    //       return {
    //         rowspan: count,
    //         colspan: 1,
    //       };
    //     }
    //   }
    //   return {
    //     rowspan: 1,
    //     colspan: 1,
    //   };
    // }
  }
}
</script>

<style lang="scss" scoped>
.point-d {
  width: 100%;
  height: 100%;
}

/deep/ .cell {
  font-size: 16px;
}

/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: var(--theme-color-customized-1);
  }

  th:last-child>.cell {
    text-align: center;
  }
}
</style>